import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as dispatchClose } from '../../../modules/modal/actions';

export const PromotionTerms = ({ close }) => (
  <div className="modal modal--zero-padding">
    <div className="modal__content-scrollable modal__content-scrollable--with-padding">
      <div className="modal__header">
        Terms & Conditions
      </div>
      <p className="modal__paragraph">
        When you place your first bet of £10/10€ or more we will give you 3 x £10 free bets.
        You must stake a minimum of £10/10€ on your first bet.
        Your first bet must be placed on a selection(s) with
        single/cumulative odds greater than 1/2 (1.5).
        For Each Way bets, only the win part counts towards the C30 promotion.
        E.g. £5 E/W (total stake £10) would not qualify for the promotion,
        however a minimum of £10 E/W (total stake £20) would trigger the 3x£10 free bets.
        The free bet will be awarded upon placement of qualifying bet.
        This offer is only available to new William Hill customers who open an account
        using a valid promo code. Available to customers in UK, Ireland, Jersey,
        Guernsey and Isle of Man.
        Customers using Skrill, Skrill 1-Tap, Neteller, Moneybookers or PaySafe
        to deposit will not qualify for the C30 promotion.
        Duplicate accounts will not qualify for this offer. Only 'one new account
        offer' per person, household address, email address, debit/credit card number,
        or IP address is allowed.
        William Hill reserve the right to withhold or reclaim any free bet stakes
        allocated to customers not in the above territories by mistake.
        William Hill reserve the right to withhold any free bets if we believe
        that the promotion has been abused or where irregular betting patterns have been discovered.
        Free bets must be placed within 30 days of award otherwise they will expire.
        Free bet stakes are not returned as part of the settlement of successful free bets.
        Free bets can be spent on any bet type.
        Free bets cannot be used to fund tote, pool or lottery bets.
        Free bets are non-refundable.
        Free bets cannot be redeemed on any other online product (Poker, Casino, Vegas, Bingo,
        Games). This offer is valid until 23:59:59 31st December 2017.
        Free bet stake not included in any winnings.
        Your free bet must be used as one single transaction and cannot be partially redeemed.
        Redeemed free bets will not qualify for any future free bets.
        Qualifying bets must be placed from the customer funded balance.
        Redeemed free bets will not count toward qualification to view streamed events.
        More information is available here explaining how to enter your
        promo code and how to redeem your free bet.
      </p>
    </div>
    <div className="modal__sticky-footer">
      <Button className="modal__button button--primary" onClick={close}>Close</Button>
    </div>
  </div>
);

PromotionTerms.propTypes = {
  close: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  close: dispatchClose
};

export default connect(null, mapDispatchToProps)(PromotionTerms);
